import * as React from "react"
import { cn } from "../../lib/utils"
import { Upload, CheckCircle } from "lucide-react"

// File Upload Component
const FileUpload = React.forwardRef(({ 
    id = "fileUpload", 
    label = "Upload File", 
    accept = "*", 
    onChange,
    className,
    ...props 
}, ref) => {
    const [dragActive, setDragActive] = React.useState(false);
    const [uploaded, setUploaded] = React.useState(false);
    const [fileName, setFileName] = React.useState("");
    const inputRef = React.useRef(null);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(e.type === "dragenter" || e.type === "dragover");
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files?.[0]) {
            setFileName(e.dataTransfer.files[0].name);
            setUploaded(true);
            onChange?.(e.dataTransfer.files);
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files?.[0]) {
            setFileName(e.target.files[0].name);
            setUploaded(true);
            onChange?.(e.target.files);
        }
    };

    return (
        <div className={cn("grid w-full gap-1.5", className)} {...props}>
            {uploaded ? (
                <div
                    className={cn(
                        "flex items-center justify-between gap-3 w-full rounded-lg border border-primary bg-primary/10 py-4 px-6 h-[46px] transition-colors",
                        "hover:bg-primary/20"
                    )}
                >
                    <CheckCircle className="h-5 w-5 text-primary" />
                    <span className="text-sm font-medium text-theme-primary">File Upload Completed</span>
                    <span className="text-sm text-theme-secondary"></span>
                </div>
            ) : (
                <div
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}
                    onClick={() => inputRef.current?.click()}
                    className={cn(
                        "flex items-center gap-3 w-full rounded-lg border border-input py-4 px-6 h-[46px] cursor-pointer transition-colors",
                        "hover:bg-theme-primary/10 hover:text-accent-foreground",
                        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                        dragActive && "border-primary bg-primary/10"
                    )}
                >
                    <Upload className="h-5 w-5 text-muted-foreground" />
                    <span className="text-sm font-medium text-muted-foreground">{label}</span>
                </div>
            )}
            <input 
                ref={inputRef}
                id={id} 
                type="file" 
                accept={accept} 
                onChange={handleFileChange} 
                className="hidden" 
            />
        </div>
    );
});

FileUpload.displayName = "FileUpload"

export { FileUpload }
export default FileUpload